import {
  useWorkHistoryPresentCount,
  useWorkHistoryPresentRoles,
} from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-details/components/work-history';
import { JobHistory } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/person-job-info/components/job-history';
import { useDisplayJobTitle } from '@aibees/elephant/hooks';
import {
  Chip,
  CustomPopover,
  TextEllipsis,
  usePopover,
} from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo, useState } from 'react';
import { PreviousEmploymentBadge } from '../previous-employment-badge';
import * as Styled from './styles';
import * as SX from './sx';
import type { PersonTitleProps as Props } from './types';

const ANCHOR_ORIGIN = {
  vertical: 'bottom' as const,
  horizontal: 'right' as const,
};
const TRANSFORM_ORIGIN = {
  vertical: 'top' as const,
  horizontal: 'right' as const,
};

export const PersonTitle = memo(({ className, data }: Props) => {
  const state = usePopover();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const allPresentRoles = useWorkHistoryPresentRoles(data);
  const totalPresentRolesCount = useWorkHistoryPresentCount(data);
  const displayTitle = useDisplayJobTitle(data, 'No title available');

  const handleJobPopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    state.onOpen(event.currentTarget);
  };

  return (
    <Styled.Wrapper
      className={classnames('PersonTitle', className)}
      sx={SX.root}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      gap={2}
    >
      <TextEllipsis variant="body3" value={displayTitle} />
      <PreviousEmploymentBadge personData={data} />

      {totalPresentRolesCount > 1 && (
        <Chip
          label={`+${totalPresentRolesCount - 1}`}
          size="small"
          color="primary"
          variant="filled"
          shape="rounded"
          onClick={handleJobPopoverOpen}
          sx={{ cursor: 'pointer' }}
        />
      )}

      <CustomPopover
        state={state}
        anchorEl={anchorEl}
        anchorOrigin={ANCHOR_ORIGIN}
        transformOrigin={TRANSFORM_ORIGIN}
        contentSx={{ overflowY: 'hidden' }}
        disableRestoreFocus
      >
        <JobHistory isCompanySummary={false} currentRoles={allPresentRoles} />
      </CustomPopover>
    </Styled.Wrapper>
  );
});

PersonTitle.displayName = 'PersonTitle';
